import React from "react";

import { useRouterSearchParams } from "@/hooks/router";
import EventPage from "@/pages/Event/EventPage";

function Page(): React.JSX.Element {
  const eventId = useRouterSearchParams("eventId", "1");
  return <EventPage eventId={eventId} />;
}

export default Page;
